export const root = "rj8jghh";
export const iconContainer = "i1791sn6";
export const fixedDimensions = "f11jyflc";
export const titleContainer = "t1aikinl";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");